import script from "./RepairPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RepairPage.vue?vue&type=script&setup=true&lang=js"

import "./RepairPage.vue?vue&type=style&index=0&id=ffdc04f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffdc04f2"]])

export default __exports__